<template>
  <div class="add-tag">
    <form @submit="onSubmit">
        <ion-searchbar search-icon="add" :value="title" @ionInput="title = $event.target.value"  @keyup="keyEvent" @change="suggest" placeholder="Neuen Tags eingeben..."/>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "AddTag",
  data() {
    return {
      title: ""
    };
  },
  methods: {
    ...mapActions(["addTag"]),
    onSubmit(e) {
      e.preventDefault();
      this.addTag(this.title);
    },
    keyEvent(e) {
      this.title = this.title.toLowerCase();
      this.title = this.title.replace(/[^\w\säüöß\-\\.]/gi, '');
    },
    suggest(e){
      //this.title = this.title.toLowerCase();
    }
  }
};
</script>

<style scoped>
  ion-searchbar {
    --background: #3E4143;
    --color: white;
    --icon-color: #B6B6B6;
    --border-radius: 35px;
  }
  .add-tag {
    margin-top: 50px;
  }
</style>
